<a (click)="sortModel.switchSortDirection()">
  {{ columnName | translate }}
  @if (sortModel?.active) {
    <span [ngClass]="{ sortingAsc: sortModel.isOpen, sortingDesc: !sortModel.isOpen }" class="fa-solid"></span>
  }
</a>
